<style lang="less" scoped>
ul,li{
  list-style: none;
  margin: 0;
  padding: 0;
}
.content{
    width: 100%;
    height: 100%;
  .contentTitle{
    height: 50px;
    line-height: 50px;
    display: flex;
    border-bottom: 1px solid #EDEEF1;
    padding: 0 30px;
    justify-content: space-between;
    .left{
      color: #000000;
      font-size: 16px;
      font-weight: 600;
    }
    .right{
      display: flex;
      padding-top: 12px;
      .cancel-btn{
        margin:0 10px;
        width: 80px;
        height: 24px;
        line-height: 24px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #DBD1CD;
        text-align: center;
        color: #867D7B;
      }
      .add-btn{
        width: 80px;
        height: 24px;
        line-height: 22px;
        text-align: center;
        border-radius: 2px;
      }
    }
  }
  .bottom{
    padding: 20px 30px;
    .add-mess{
      width: 100%;
      min-height: 160px;
      background: #F1F0F0;
      border-radius: 4px;
      padding: 20px;
      .mess-top{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .time{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #867D7B;
          line-height: 20px;
        }
        .edit{
          cursor: pointer;
          color: #bdb6b4;
          .edit-fun{
            font-size: 18px;
            margin-right: 10px;
          }
        }
        .publish{
          width: 80px;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: #F1F0F0;
          border-radius: 2px;
          border: 1px solid @primary-color;
          color: @primary-color;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .mess-bot{

      }
    }
    .input-text{
      position: relative;
      .textArea{
        resize: none;
      }
      .tipLimit{
        position: absolute;
        right: 10px;
        bottom: 10px;
        .tipLimit0{

        }
        .tipLimit200{

        }
      }
    }
    .list-history{
      margin-top: 20px;
      line-height: 50px;
      .history-title{
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #867D7B;
        line-height: 22px;
      }
      .list-ul{

      }
      .list-li{
        display: flex;
        border-bottom: 1px solid #edeef1;
        padding: 20px 0px;
        .left{
          width: calc(100% - 20px);
          line-height: 30px;
          .top{

          }
          .bot{

          }
        }
        .right{
          width: 50px;
          text-align: right;
          cursor: pointer;
          color: #DB5647;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
    .area{
      margin-top: 15px;
      .notice-input{

      }
      /deep/textarea{
        background: #F1F0F0;
        border: none;
        resize: none;
        color: #333;
        font-size: 16px;
      }
    }
    .del-fun{
      font-size: 18px;
      cursor: pointer;
      color: #bdb6b4;
    }
    .list{
      width: 100%;
      height: 100%;
      text-align: center;
      .no-data{
        text-align: center;
        margin-top: 60px;
      }
      .no-notice{
        color: #867D7B;
        font-size: 14px;
        text-align: center;
      }
      .add-now{
        width: 120px;
        height: 32px;
        background: @primary-color;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin: 0 auto;
        margin-top: 60px;
        color: #fff;
        cursor: pointer;
      }
    }
  }

}
</style>
<template>
<div class="content">
  <div class="contentTitle">
    <div class="left"> 班级公告</div>
    <div class="right">
      <a-button v-show="showNotice||noticeMess==null"  type="primary" class="add-btn" @click="addFun">
        <a-icon type="plus-circle" />添加
      </a-button>
      <a-button v-show="!showNotice"  type="primary" class="cancel-btn" @click="cancelPublish">取消</a-button>
      <a-button v-show="!showNotice"  type="primary" class="add-btn" @click="publishFun">发布</a-button>
    </div>
  </div>
  <div class="bottom">
    <div class="add-mess" v-show="showNotice&&noticeMess!=''">
      <div class="area">
        <a-textarea
          v-model="addNoticeText"
          class="notice-input"
          placeholder="请输入班级公告"
          :auto-size="{ minRows: 3, maxRows: 5 }"
          :disabled="textDisabled"
        />
      </div>
      <div class="mess-top">
        <div class="time">{{format.format(nowTime)}}</div>
        <div class="edit">
          <a-icon class="edit-fun" @click="editNoticeFun()" type="form" />
          <a-popconfirm placement="right" title="删除的公告不可恢复，确定删除吗？" ok-text="删除" cancel-text="取消" @confirm="delFun(noticeMess,true)">
             <a-icon class="del-fun" type="delete" />
          </a-popconfirm>
        </div>
      </div>
    </div>
    <div class="input-text"  v-show="!showNotice">
      <a-textarea class="textArea" type="textarea" placeholder="请输入公告" :maxLength="textLength" suffix="false" v-model="addNoticeText" @change="noticeChange" :rows="5" />
      <div class="tipLimit">
        <span class="tipLimit0">{{number}}</span>
        <span>/</span>
        <span class="tipLimit200">200</span>
      </div>
    </div>
    <div v-show="noticeList.length > 0" class="list-history">
      <div class="history-title">历史公告</div>
      <ul class="list-ul">
        <li class="list-li" v-for="(item, index) in noticeList" :key="index">
          <div class="left">
            <div class="top">{{item.content}}</div>
            <div class="bot">
              发布于：{{format.format(item.createDate)}}
            </div>
          </div>
          <a-popconfirm placement="right" title="删除的公告不可恢复，确定删除吗？" ok-text="删除" cancel-text="取消" @confirm="delFun(item,false)">
            <a-icon class="del-fun" type="delete" />
          </a-popconfirm>
        </li>
      </ul>
    </div>
    <div class="list" v-show="noticeList.length == 0&&noticeMess==''">
      <img class="no-data" :src="noDataImg" alt="">
      <div class="no-notice">暂无班级公告</div>
      <div class="add-now" @click="addFun">立即添加</div>
    </div>
  </div>
  </div>
</template>

<script>
import requestUrl from '../../../utils/requestUrl.js'
import format from '../../../utils/format.js'
export default {
  name: 'Notice',
  data () {
    return {
      format,
      noticeList: [],
      access_token: this.$store.state.access_token,
      classId: '',
      currentClassId: this.$store.state.currentClassId,
      nowTime: '',
      noticeMess: null,
      textDisabled: true,
      addNoticeText: '',
      showNotice: true,
      number: 0,
      textLength: 200,
      noDataImg: require('../../../assets/image/no-data.png')
    }
  },
  computed: {
    getCurrentClassId () {
      return this.$store.state.currentClassId
    }
  },
  watch: {
    addNoticeText() {
      this.number = addNoticeText.length
    }
  },
  mounted() {
    if (this.$store.getters.currentClass) {
      this.getLastNotice()
      this.getList()
    }
  },
  watch: {
    getCurrentClassId (val) {
      this.currentClassId = val
      this.getLastNotice()
      this.getList()
    }
  },
  methods: {
    getLastNotice() {
       const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.getNewestClassAnnouncement, param).then(res => {
        if (res) {
          this.noticeMess = res
          this.addNoticeText = res.content
          this.nowTime = res.createDate
        }else{
          this.noticeMess = ''
          this.addNoticeText = ''
        }
      })
    },
    getList () {
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.getClassAnnouncements, param).then(res => {
        if (res) {
          this.noticeList = res
        }else{
          this.noticeList = []
        }
      })
    },
    cancelPublish() {
      this.showNotice = true
      this.getLastNotice()
    },
    addFun() {
      this.showNotice = false
      this.addNoticeText = ''
      this.nowTime = (new Date()).valueOf()
    },
    noticeChange(val) {
      this.addNoticeText = val.target.value
      this.number = val.target.value.length
      // console.log(val.target.value)
    },
    publishFun () {
      if (this.addNoticeText == '') {
        this.$message.warning('请输入公告')
        return
      }
      if (this.addNoticeText.length > 200) {
        this.$message.warning('请控制在200字以内')
        return
      }
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId,
        content: this.addNoticeText
      }
      this.$http.post(requestUrl.pushClassAnnouncement, param).then(res => {
        if (res) {
          this.$message.success('发布成功')
          this.showNotice = false
          this.showNotice = true
          this.getList()
          this.getLastNotice()
        }
      })
    },
    editNoticeFun() {
      this.showNotice = false
      this.number = this.addNoticeText.length
    },
    delFun(item, flag) {
      if (flag&&item&&Object.keys(item).length==0) {
        return
      }
       const param = {
        access_token: this.access_token,
        id: item.id
      }
      this.$http.post(requestUrl.delClassAnnouncements, param).then(res => {
        if (res) {
          this.$message.success('删除成功')
          if (flag) {
            this.getLastNotice()
          } else {
            this.getList()
          }

        }
      })
    },
    del (item, index) {
      this.noticeList.splice(index, 1)
    }
  }
}
</script>
